import { Injectable } from '@angular/core';
import { ENV } from '@app/env';
import 'rxjs/add/operator/map';

@Injectable()
export class EnvService {
    // Re-duce, Re-use, Re-websling
    constructor() {
        console.log('Just your friendly neighborhood EnvServiceProvider Man');
    }
    /**
     * @method getAppUrl
     *
     * @param {string} overrideDomain - pass in domain string to override current.. ie: 'materials' -> 'dashboards'
     * @param {srtring} endTarget - ['api', 'assets', 'none' || ''] - defaults to 'api' if undefined
     *  - Defaults to 'api' which will return '/1.0' api url.
     *  - 'assets' will return an '/Assets' url instead of api,
     *  - 'none' will return just the app url.
     * @param {string} append - any string that should be appended to the final result.
     */
    getAppUrl(overrideDomain?:string, endTarget:string = 'api', append?:string) {
        console.log('getAppUrl input:', {overrideDomain, endTarget, append});
        let haveSwitchedEnv = window.localStorage.getItem("env");
        let api_url = ENV.API_URL;
        let app_url;
        let buildEnv = ENV.BUILD;
        let href = window.location.href;
        if (buildEnv) {
            api_url = ENV.API_URLS[buildEnv];
        } else if (api_url === '/1.0/' && !overrideDomain && endTarget === 'api' && !append && !haveSwitchedEnv && !href.includes('localhost')) {
            // just return the thing
            console.log('getAppUrl output:', api_url);
            return api_url;
        } else {
            const findDomain = (term) => {
                if (href.includes(term)){
                    return href;
                }
            };
            switch(href) {
                case findDomain('localhost'):
                case findDomain('qa'):
                    api_url = ENV.API_URLS.qa;
                    break;
                case findDomain('stg'):
                    api_url = ENV.API_URLS.stg;
                    break;
                case findDomain('demo'):
                    api_url = ENV.API_URLS.demo;
                    break;
                default:
                    api_url = ENV.API_URLS.prod;
                    break;
            }
        }
        let parser = document.createElement('a');
        // If we've server switched then just use that
        if (haveSwitchedEnv) {
            if (ENV.API_URLS[window.localStorage.getItem("env")]) {
                api_url = ENV.API_URLS[window.localStorage.getItem("env")];
            }
        }

        parser.href = api_url;
        app_url = parser.hostname;
        // handle old style
        if (overrideDomain) {
            app_url = `${overrideDomain}.${app_url}`;
        } else if (!overrideDomain && endTarget) {
            app_url = `${endTarget}.${app_url}`;
        }
        if (endTarget) {
            switch(endTarget.toLowerCase()) {
                case 'api':
                    if (overrideDomain && overrideDomain.indexOf('dashboard') > -1) {
                        // do nothing
                    } else {
                        app_url += '/1.0/';
                    }
                    break;
                case 'assets':
                    app_url += '/Assets/';
                    break;
                case 'dashboards':
                case 'dashboard':
                case 'twip':
                case 'none':
                case '':
                    app_url + '';
                    break;
            }
        }
        if (append) {
            // if it starts with / and app_url ends with / ... get it outta there
            if (append[0] === '/' && app_url[app_url.length - 1] === '/') {
                append = append.substr(1, append.length);
            }
            app_url += append;
        }
        console.log('getAppUrl output:', `${parser.protocol}//${app_url}`);
        return `${parser.protocol}//${app_url}`;
    }


}



// WEBPACK FOOTER //
// ./src/providers/env-friendly-service/env-friendly-service.ts